'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  background: _propTypes2.default.string,
  backgroundBlendMode: _propTypes2.default.string,
  backgroundClip: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  backgroundImage: _propTypes2.default.string,
  backgroundOrigin: _propTypes2.default.string,
  backgroundPosition: _propTypes2.default.string,
  backgroundRepeat: _propTypes2.default.string,
  backgroundSize: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _background = {
  className: 'bg',
  cssName: 'background',
  jsName: 'background',
  isPrefixed: true,
  complexValue: true
};
var _backgroundColor = {
  className: 'bg-clr',
  cssName: 'background-color',
  jsName: 'backgroundColor'
};
var _backgroundImage = {
  className: 'bg-img',
  cssName: 'background-image',
  jsName: 'backgroundImage',
  isPrefixed: true,
  complexValue: true
};
var _backgroundPosition = {
  className: 'bg-pos',
  cssName: 'background-position',
  jsName: 'backgroundPosition'
};
var _backgroundSize = {
  className: 'bg-siz',
  cssName: 'background-size',
  jsName: 'backgroundSize'
};
var _backgroundOrigin = {
  className: 'bg-orgn',
  cssName: 'background-origin',
  jsName: 'backgroundOrigin'
};
var _backgroundRepeat = {
  className: 'bg-rpt',
  cssName: 'background-repeat',
  jsName: 'backgroundRepeat'
};
var _backgroundClip = {
  className: 'bg-clp',
  cssName: 'background-clip',
  jsName: 'backgroundClip'
};
var _backgroundBlendMode = {
  className: 'bg-blnd-md',
  cssName: 'background-blend-mode',
  jsName: 'backgroundBlendMode'
};

var propEnhancers = exports.propEnhancers = {
  background: function background(value) {
    return (0, _getCss2.default)(_background, value);
  },
  backgroundBlendMode: function backgroundBlendMode(value) {
    return (0, _getCss2.default)(_backgroundBlendMode, value);
  },
  backgroundClip: function backgroundClip(value) {
    return (0, _getCss2.default)(_backgroundClip, value);
  },
  backgroundColor: function backgroundColor(value) {
    return (0, _getCss2.default)(_backgroundColor, value);
  },
  backgroundImage: function backgroundImage(value) {
    return (0, _getCss2.default)(_backgroundImage, value);
  },
  backgroundOrigin: function backgroundOrigin(value) {
    return (0, _getCss2.default)(_backgroundOrigin, value);
  },
  backgroundPosition: function backgroundPosition(value) {
    return (0, _getCss2.default)(_backgroundPosition, value);
  },
  backgroundRepeat: function backgroundRepeat(value) {
    return (0, _getCss2.default)(_backgroundRepeat, value);
  },
  backgroundSize: function backgroundSize(value) {
    return (0, _getCss2.default)(_backgroundSize, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvYmFja2dyb3VuZC5qcyJdLCJuYW1lcyI6WyJwcm9wVHlwZXMiLCJiYWNrZ3JvdW5kIiwiUHJvcFR5cGVzIiwic3RyaW5nIiwiYmFja2dyb3VuZEJsZW5kTW9kZSIsImJhY2tncm91bmRDbGlwIiwiYmFja2dyb3VuZENvbG9yIiwiYmFja2dyb3VuZEltYWdlIiwiYmFja2dyb3VuZE9yaWdpbiIsImJhY2tncm91bmRQb3NpdGlvbiIsImJhY2tncm91bmRSZXBlYXQiLCJiYWNrZ3JvdW5kU2l6ZSIsInByb3BBbGlhc2VzIiwicHJvcFZhbGlkYXRvcnMiLCJjbGFzc05hbWUiLCJjc3NOYW1lIiwianNOYW1lIiwiaXNQcmVmaXhlZCIsImNvbXBsZXhWYWx1ZSIsInByb3BFbmhhbmNlcnMiLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVPLElBQU1BLGdDQUFZO0FBQ3ZCQyxjQUFZQyxvQkFBVUMsTUFEQztBQUV2QkMsdUJBQXFCRixvQkFBVUMsTUFGUjtBQUd2QkUsa0JBQWdCSCxvQkFBVUMsTUFISDtBQUl2QkcsbUJBQWlCSixvQkFBVUMsTUFKSjtBQUt2QkksbUJBQWlCTCxvQkFBVUMsTUFMSjtBQU12Qkssb0JBQWtCTixvQkFBVUMsTUFOTDtBQU92Qk0sc0JBQW9CUCxvQkFBVUMsTUFQUDtBQVF2Qk8sb0JBQWtCUixvQkFBVUMsTUFSTDtBQVN2QlEsa0JBQWdCVCxvQkFBVUM7QUFUSCxDQUFsQjs7QUFZQSxJQUFNUyxvQ0FBYyxFQUFwQjs7QUFFQSxJQUFNQywwQ0FBaUIsRUFBdkI7O0FBRVAsSUFBTVosY0FBYTtBQUNqQmEsYUFBVyxJQURNO0FBRWpCQyxXQUFTLFlBRlE7QUFHakJDLFVBQVEsWUFIUztBQUlqQkMsY0FBWSxJQUpLO0FBS2pCQyxnQkFBYztBQUxHLENBQW5CO0FBT0EsSUFBTVosbUJBQWtCO0FBQ3RCUSxhQUFXLFFBRFc7QUFFdEJDLFdBQVMsa0JBRmE7QUFHdEJDLFVBQVE7QUFIYyxDQUF4QjtBQUtBLElBQU1ULG1CQUFrQjtBQUN0Qk8sYUFBVyxRQURXO0FBRXRCQyxXQUFTLGtCQUZhO0FBR3RCQyxVQUFRLGlCQUhjO0FBSXRCQyxjQUFZLElBSlU7QUFLdEJDLGdCQUFjO0FBTFEsQ0FBeEI7QUFPQSxJQUFNVCxzQkFBcUI7QUFDekJLLGFBQVcsUUFEYztBQUV6QkMsV0FBUyxxQkFGZ0I7QUFHekJDLFVBQVE7QUFIaUIsQ0FBM0I7QUFLQSxJQUFNTCxrQkFBaUI7QUFDckJHLGFBQVcsUUFEVTtBQUVyQkMsV0FBUyxpQkFGWTtBQUdyQkMsVUFBUTtBQUhhLENBQXZCO0FBS0EsSUFBTVIsb0JBQW1CO0FBQ3ZCTSxhQUFXLFNBRFk7QUFFdkJDLFdBQVMsbUJBRmM7QUFHdkJDLFVBQVE7QUFIZSxDQUF6QjtBQUtBLElBQU1OLG9CQUFtQjtBQUN2QkksYUFBVyxRQURZO0FBRXZCQyxXQUFTLG1CQUZjO0FBR3ZCQyxVQUFRO0FBSGUsQ0FBekI7QUFLQSxJQUFNWCxrQkFBaUI7QUFDckJTLGFBQVcsUUFEVTtBQUVyQkMsV0FBUyxpQkFGWTtBQUdyQkMsVUFBUTtBQUhhLENBQXZCO0FBS0EsSUFBTVosdUJBQXNCO0FBQzFCVSxhQUFXLFlBRGU7QUFFMUJDLFdBQVMsdUJBRmlCO0FBRzFCQyxVQUFRO0FBSGtCLENBQTVCOztBQU1PLElBQU1HLHdDQUFnQjtBQUMzQmxCLGNBQVk7QUFBQSxXQUFTLHNCQUFPQSxXQUFQLEVBQW1CbUIsS0FBbkIsQ0FBVDtBQUFBLEdBRGU7QUFFM0JoQix1QkFBcUI7QUFBQSxXQUFTLHNCQUFPQSxvQkFBUCxFQUE0QmdCLEtBQTVCLENBQVQ7QUFBQSxHQUZNO0FBRzNCZixrQkFBZ0I7QUFBQSxXQUFTLHNCQUFPQSxlQUFQLEVBQXVCZSxLQUF2QixDQUFUO0FBQUEsR0FIVztBQUkzQmQsbUJBQWlCO0FBQUEsV0FBUyxzQkFBT0EsZ0JBQVAsRUFBd0JjLEtBQXhCLENBQVQ7QUFBQSxHQUpVO0FBSzNCYixtQkFBaUI7QUFBQSxXQUFTLHNCQUFPQSxnQkFBUCxFQUF3QmEsS0FBeEIsQ0FBVDtBQUFBLEdBTFU7QUFNM0JaLG9CQUFrQjtBQUFBLFdBQVMsc0JBQU9BLGlCQUFQLEVBQXlCWSxLQUF6QixDQUFUO0FBQUEsR0FOUztBQU8zQlgsc0JBQW9CO0FBQUEsV0FBUyxzQkFBT0EsbUJBQVAsRUFBMkJXLEtBQTNCLENBQVQ7QUFBQSxHQVBPO0FBUTNCVixvQkFBa0I7QUFBQSxXQUFTLHNCQUFPQSxpQkFBUCxFQUF5QlUsS0FBekIsQ0FBVDtBQUFBLEdBUlM7QUFTM0JULGtCQUFnQjtBQUFBLFdBQVMsc0JBQU9BLGVBQVAsRUFBdUJTLEtBQXZCLENBQVQ7QUFBQTtBQVRXLENBQXRCIiwiZmlsZSI6ImJhY2tncm91bmQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgZ2V0Q3NzIGZyb20gJy4uL2dldC1jc3MnXG5cbmV4cG9ydCBjb25zdCBwcm9wVHlwZXMgPSB7XG4gIGJhY2tncm91bmQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGJhY2tncm91bmRCbGVuZE1vZGU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGJhY2tncm91bmRDbGlwOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBiYWNrZ3JvdW5kQ29sb3I6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGJhY2tncm91bmRJbWFnZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgYmFja2dyb3VuZE9yaWdpbjogUHJvcFR5cGVzLnN0cmluZyxcbiAgYmFja2dyb3VuZFBvc2l0aW9uOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBiYWNrZ3JvdW5kUmVwZWF0OiBQcm9wVHlwZXMuc3RyaW5nLFxuICBiYWNrZ3JvdW5kU2l6ZTogUHJvcFR5cGVzLnN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgcHJvcEFsaWFzZXMgPSB7fVxuXG5leHBvcnQgY29uc3QgcHJvcFZhbGlkYXRvcnMgPSB7fVxuXG5jb25zdCBiYWNrZ3JvdW5kID0ge1xuICBjbGFzc05hbWU6ICdiZycsXG4gIGNzc05hbWU6ICdiYWNrZ3JvdW5kJyxcbiAganNOYW1lOiAnYmFja2dyb3VuZCcsXG4gIGlzUHJlZml4ZWQ6IHRydWUsXG4gIGNvbXBsZXhWYWx1ZTogdHJ1ZVxufVxuY29uc3QgYmFja2dyb3VuZENvbG9yID0ge1xuICBjbGFzc05hbWU6ICdiZy1jbHInLFxuICBjc3NOYW1lOiAnYmFja2dyb3VuZC1jb2xvcicsXG4gIGpzTmFtZTogJ2JhY2tncm91bmRDb2xvcidcbn1cbmNvbnN0IGJhY2tncm91bmRJbWFnZSA9IHtcbiAgY2xhc3NOYW1lOiAnYmctaW1nJyxcbiAgY3NzTmFtZTogJ2JhY2tncm91bmQtaW1hZ2UnLFxuICBqc05hbWU6ICdiYWNrZ3JvdW5kSW1hZ2UnLFxuICBpc1ByZWZpeGVkOiB0cnVlLFxuICBjb21wbGV4VmFsdWU6IHRydWVcbn1cbmNvbnN0IGJhY2tncm91bmRQb3NpdGlvbiA9IHtcbiAgY2xhc3NOYW1lOiAnYmctcG9zJyxcbiAgY3NzTmFtZTogJ2JhY2tncm91bmQtcG9zaXRpb24nLFxuICBqc05hbWU6ICdiYWNrZ3JvdW5kUG9zaXRpb24nXG59XG5jb25zdCBiYWNrZ3JvdW5kU2l6ZSA9IHtcbiAgY2xhc3NOYW1lOiAnYmctc2l6JyxcbiAgY3NzTmFtZTogJ2JhY2tncm91bmQtc2l6ZScsXG4gIGpzTmFtZTogJ2JhY2tncm91bmRTaXplJ1xufVxuY29uc3QgYmFja2dyb3VuZE9yaWdpbiA9IHtcbiAgY2xhc3NOYW1lOiAnYmctb3JnbicsXG4gIGNzc05hbWU6ICdiYWNrZ3JvdW5kLW9yaWdpbicsXG4gIGpzTmFtZTogJ2JhY2tncm91bmRPcmlnaW4nXG59XG5jb25zdCBiYWNrZ3JvdW5kUmVwZWF0ID0ge1xuICBjbGFzc05hbWU6ICdiZy1ycHQnLFxuICBjc3NOYW1lOiAnYmFja2dyb3VuZC1yZXBlYXQnLFxuICBqc05hbWU6ICdiYWNrZ3JvdW5kUmVwZWF0J1xufVxuY29uc3QgYmFja2dyb3VuZENsaXAgPSB7XG4gIGNsYXNzTmFtZTogJ2JnLWNscCcsXG4gIGNzc05hbWU6ICdiYWNrZ3JvdW5kLWNsaXAnLFxuICBqc05hbWU6ICdiYWNrZ3JvdW5kQ2xpcCdcbn1cbmNvbnN0IGJhY2tncm91bmRCbGVuZE1vZGUgPSB7XG4gIGNsYXNzTmFtZTogJ2JnLWJsbmQtbWQnLFxuICBjc3NOYW1lOiAnYmFja2dyb3VuZC1ibGVuZC1tb2RlJyxcbiAganNOYW1lOiAnYmFja2dyb3VuZEJsZW5kTW9kZSdcbn1cblxuZXhwb3J0IGNvbnN0IHByb3BFbmhhbmNlcnMgPSB7XG4gIGJhY2tncm91bmQ6IHZhbHVlID0+IGdldENzcyhiYWNrZ3JvdW5kLCB2YWx1ZSksXG4gIGJhY2tncm91bmRCbGVuZE1vZGU6IHZhbHVlID0+IGdldENzcyhiYWNrZ3JvdW5kQmxlbmRNb2RlLCB2YWx1ZSksXG4gIGJhY2tncm91bmRDbGlwOiB2YWx1ZSA9PiBnZXRDc3MoYmFja2dyb3VuZENsaXAsIHZhbHVlKSxcbiAgYmFja2dyb3VuZENvbG9yOiB2YWx1ZSA9PiBnZXRDc3MoYmFja2dyb3VuZENvbG9yLCB2YWx1ZSksXG4gIGJhY2tncm91bmRJbWFnZTogdmFsdWUgPT4gZ2V0Q3NzKGJhY2tncm91bmRJbWFnZSwgdmFsdWUpLFxuICBiYWNrZ3JvdW5kT3JpZ2luOiB2YWx1ZSA9PiBnZXRDc3MoYmFja2dyb3VuZE9yaWdpbiwgdmFsdWUpLFxuICBiYWNrZ3JvdW5kUG9zaXRpb246IHZhbHVlID0+IGdldENzcyhiYWNrZ3JvdW5kUG9zaXRpb24sIHZhbHVlKSxcbiAgYmFja2dyb3VuZFJlcGVhdDogdmFsdWUgPT4gZ2V0Q3NzKGJhY2tncm91bmRSZXBlYXQsIHZhbHVlKSxcbiAgYmFja2dyb3VuZFNpemU6IHZhbHVlID0+IGdldENzcyhiYWNrZ3JvdW5kU2l6ZSwgdmFsdWUpXG59XG4iXX0=